<template>
    <div class="progressbar-chart">
        <div class="item" v-for="(item, index) in items" :key="index">
            <div class="header text-body-2">
                <label class="text">{{ item.label }}</label>
                <span>{{ `${ item.value } ${ unit }` }}</span>
            </div>
            <span class="progressbar">
                <span class="value" :style="{ width: getItemWidth(item.value) }"/>
            </span>
        </div>
    </div>
</template>

<script>
/**
 * ProgressBarChart component generates a progress bar with its label for each
 * data item provided as argument.
 */
export default {
    name: 'ProgressBarChart',
    props: {
        items: {
            type: Array,
            required: true
        },
        unit: {
            type: String,
            default: ''
        }
    },
    data: () => ({
        max: 1
    }),
    methods: {
        getItemWidth(value) {
            const width = value * 100 / this.max;
            if (width) return width != 100 ? width + '%' : '99%';
            return '1%';
        } 
    },
    watch: {
        items(newItems) {
            const values = newItems.map(item => item.value) || [ 0 ];
            this.max = Math.max(...values);
        }
    }
}
</script>

<style scoped>
.progressbar-chart {
    display: inline-block;
    vertical-align: top;
    width: 100%;
    height: auto;
    flex: 1;
}

.item {
    display: block;
    height: auto;
    margin: 8px 24px;
}

.item .header {
    display: flex;
    justify-content: space-between;
}

.item .text {
    font-size: 1.2em;
}

.item .progressbar {
    display: inline-block;
    vertical-align: top;
    position: relative;
    width: 100%;
    height: 8px;
    margin: 8px 0;
    background-color: var(--v-dddarkblue-base);
}

.item .progressbar .value {
    position: absolute;
    top: 0; left: 0;
    height: 8px;
    background-color: var(--v-ddlightblue-base);
}
</style>